export const NoClFarmRewards = () => {
  return (
    <div className="flex flex-col items-center justify-center gap-2 bg-p300 p-4 text-center">
      <div className="text-sm font-medium text-t100">No CL Farm Rewards</div>
      <div className="text-xs text-t200">You don't have any claimable rewards from CL farms at this time.</div>
    </div>
  )
}
